import React from "react";
import Banner from "../components/home/Banner";
import ImageWithContent from "../components/home/ImageWithContent";
import Service from "../components/home/Service";
import WeServe from "../components/home/IndustriesWeServe";
import KeyDifferent from "../components/home/KeyDifferentiators";
import Testimonial from "../components/home/Testimonial";
import Blog_Section from "../components/home/BlogSection";

function HomePage() {
  return (
    <div className="App">
      <Banner />
      <ImageWithContent />
      <Service />
      <WeServe />
      <KeyDifferent />
      <Testimonial />
      <Blog_Section />
    </div>
  );
}

export default HomePage;
